import { Injectable } from '@angular/core';
import { Observable, throwError as _throw } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from '../../environments';
import { TranslateService } from '@ngx-translate/core';
import { catchError, map } from 'rxjs/operators';
import { ThirdPartyConversationItem } from '../models/thirdparty-conversation-item';
import { THIRDPARTYCONVERSATIONMOCKSET } from '../views/pages/thirdparties/mock/thirdparty-conversation.table';
import { ThirdPartyFormConversations } from '../models/thirdparty-form-conversations';
import { ThirdpartyTaskConversation } from '../models/thirdparty-tracing-tasks/conversations';
import { AuthService } from '../core/auth/_services/auth.service';
import { UserType } from '../core/auth/_models/user.model';

@Injectable({
  providedIn: 'root'
})
export class ThirdpartyConversationService {
  private apiEndPoint: string;


  constructor(
    private _http: HttpClient,
    private auth: AuthService,
    private _translate: TranslateService
  ) {
    this.apiEndPoint = environment.apiUrl;
  }

  getItemConversation(id?: any): Observable<ThirdPartyConversationItem[]>{
    const params = new HttpParams()
      .append("thirdPartyEvaluationFormId", id);

    return this._http
    .get<ThirdPartyConversationItem[]>(`${this.apiEndPoint}/Conversation/GetFormConversationItem`, { params })
    .pipe(
      map( res => {
        return res;
      }),
      catchError(err => {
        if (err.errorcode) {
          return _throw(err.errorcode);
        }

        return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
      })
    );
  }

  getAllConversationsForForm(thirdPartyEvaluationFormId?: any): Observable<ThirdPartyFormConversations>{
    const params = new HttpParams()
      .append("thirdPartyEvaluationFormId", thirdPartyEvaluationFormId);

    return this._http
    .get<ThirdPartyFormConversations>(`${this.apiEndPoint}/Conversation/GetAllConversationForForm`, { params })
    .pipe(
      map( res => {
        return res;
      }),
      catchError(err => {
        if (err.errorcode) {
          return _throw(err.errorcode);
        }

        return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
      })
    );
  }

  saveAllConversationsForForm(conversations: ThirdPartyFormConversations, isContinue?: boolean): Observable<any>{
    return this._http
    .post(
      `${this.apiEndPoint}/Conversation/SaveAllConversations${(isContinue && this.auth.currentUser.userType === UserType.Hybrid) ? 'Hybrid' : ''}`,
      conversations
    )
    .pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        if (err.errorcode) {
          return _throw(err.errorcode);
        }

        return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
      })
    );
  }

  getAllConversationsForFollowUpTask(thirdPartyFollowUpTaskFormId: any): Observable<ThirdpartyTaskConversation>{
    const params = new HttpParams()
      .append("thirdPartyFollowUpTaskFormId", thirdPartyFollowUpTaskFormId);

    return this._http
    .get<ThirdpartyTaskConversation>(`${this.apiEndPoint}/Conversation/GetAllConversationForFormTasks`, { params })
    .pipe(
      map( res => {
        return res;
      }),
      catchError(err => {
        if (err.errorcode) {
          return _throw(err.errorcode);
        }

        return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
      })
    );
  }

  saveAllConversationsForFollowUpTask(conversations: ThirdpartyTaskConversation, checkThirdParty?: boolean): Observable<any>{
    return this._http
    .post(`${this.apiEndPoint}/Conversation/SaveAllConversationsTasks${(checkThirdParty && this.auth.currentUser.userType === UserType.Hybrid) ? 'Hybrid' : ''}`, conversations)
    .pipe(
      map(res => {
        return res;
      }),
      catchError(err => {
        if (err.errorcode) {
          return _throw(err.errorcode);
        }

        return _throw(this._translate.instant('BUSSINESSERRORS.ErrUnexpected'));
      })
    );
  }

}
